import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';

/* eslint-disable react/jsx-filename-extension */
import './polyfill';
// Translate
import i18n from './i18n';
import store, { history } from './redux/store/store';
import axiosInterceptor from './axios/axiosInterceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nextProvider i18n={i18n}>
    {
        axiosInterceptor(history)
      }
    <Provider store={store}>
      <App history={history} />
    </Provider>
  </I18nextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
